import '../styles/globals.css'
import 'antd/dist/antd.css';
import "react-perfect-scrollbar/dist/css/styles.css";

function MyApp({ Component, pageProps }) {
  return <Component {...pageProps} />
}

export default MyApp
